function Recommend() {
  const recommendCardList = [
    {
      imageSrc: `${process.env.PUBLIC_URL}/assets/images/home/ico_recom01.svg`,
      text: `항산화&노화방지를<br />원하시는 분`,
    },
    {
      imageSrc: `${process.env.PUBLIC_URL}/assets/images/home/ico_recom02.svg`,
      text: `심장&혈관에<br />신경이 쓰이시는분`,
    },
    {
      imageSrc: `${process.env.PUBLIC_URL}/assets/images/home/ico_recom03.svg`,
      text: `시력이 저하되고<br />눈이 침침해지시는 분`,
    },
    {
      imageSrc: `${process.env.PUBLIC_URL}/assets/images/home/ico_recom04.svg`,
      text: `두뇌 기능 기능을<br />개선하고픈 분`,
    },
    {
      imageSrc: `${process.env.PUBLIC_URL}/assets/images/home/ico_recom05.svg`,
      text: `평소 잦은 편두통이<br />고민이신 분`,
    },
    {
      imageSrc: `${process.env.PUBLIC_URL}/assets/images/home/ico_recom06.svg`,
      text: `피부 재생 세포 증진을<br />원하시는 분`,
    },
  ];
  return (
    <div className='flex items-center text-center justify-center w-full h-auto pt-16 pb-24  md:pt-40 md:pb-56 bg-gradient-to-b from-[#DBE9FA] to-[#EAF5FE]'>
      <div className='px-5'>
        <p
          className='text-2xl font-semibold leading-9 text-[#274274] md:font-bold md:text-5xl fade-01'
          data-aos='fade-up'
        >
          이런 분들께 추천 드립니다.
        </p>
        <ul
          className='flex flex-wrap justify-center mt-8 lg:mt-24 fade-02'
          data-aos='fade-up'
          data-aos-duration='1000'
        >
          {recommendCardList.map((item, idx) => (
            <li
              className={`py-7 w-[calc(50%-6px)] lg:w-[calc(33.3%-56px)] bg-white mb-[22px] lg:mb-[52px] rounded-xl lg:ml-[28px] ${
                idx % 2 ? 'ml-[12px]' : ''
              } lg:${idx === 0 && idx === 3 ? 'ml-0' : ''}`}
              key={item.text}
            >
              <img
                className='inline-block w-20 h-20 lg:w-[160px] lg:h-[160px]'
                src={item.imageSrc}
                alt=''
              />
              <p
                className='text-sm font-semibold leading-5 mt-7 lg:text-2xl'
                dangerouslySetInnerHTML={{ __html: item.text }}
              ></p>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default Recommend;
